import React from 'react';
import { Section } from '@radix-ui/themes';

import PageTitle from 'components/layout/PageTitle';
import BoardWrite from 'components/board/BoardWrite';

// 게시판 관리 > 주요결과 관리 > 등록
export default function ResultWrite() {
  const boardType = 'result';

  return (
    <Section>
      <PageTitle title="주요결과 등록" />
      <BoardWrite boardType={boardType} />
    </Section>
  );
}
